import { AxiosError } from 'axios';
import { BaseClient } from '../client';
import { IndicacaoApiResponse, IndicacaoConfiguracao } from './indicacao.types';

export const getIndicacaoConfiguracao = async () => {
	try {
		const response = await BaseClient.get<IndicacaoApiResponse<IndicacaoConfiguracao>>(
			'v2/Indicacao/Configuracao'
		);
		return response.data;
	} catch (error) {
		const axiosError = error as AxiosError<IndicacaoApiResponse<IndicacaoConfiguracao>>;
		if (axiosError.response?.data?.message) {
			return axiosError.response.data;
		}
		throw error;
	}
};
